
import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';

import { Link, useNavigate } from "react-router-dom";

import TocIcon from '@mui/icons-material/Toc';

import NextSectionButton from "./NextSectionButton";
import SettingsModal from "./SettingsModal";
import styles from '../../styles/layouts/DashboardHeaderBar.module.css'
import { GiHamburgerMenu } from "react-icons/gi";


const BuyersGuideHeader = ({ onDrawerToggle, buyersGuide: { specificBuyersGuideData, buyersGuideDataChecked } }) => {
    const navigate = useNavigate();
    const [openSettings, setOpenSettings] = useState(false)
    
    useEffect(() => {
        if (!specificBuyersGuideData?.buyers_guide_id) {
            navigate(`/buyers-guide`)
        }
    }, [specificBuyersGuideData, buyersGuideDataChecked])

    return (
        <React.Fragment>
            <div className={styles.buyers_guider_header_navigation}>
                <div>
                    <div className={styles.headerBar_hamburger_icon}>
                        <GiHamburgerMenu size={30} onClick={onDrawerToggle} />
                    </div>
                </div>

                
                <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                    <div style={{ cursor: 'pointer' }} onClick={() => { setOpenSettings(true) }}>
                        <TocIcon />
                    </div>
                    <NextSectionButton />
                </div>
                    
            </div>
            <SettingsModal
                open={openSettings}
                closeModal={() => { setOpenSettings(false) }}
            />
            
        </React.Fragment>
    )
};

const mapStateToProps = state => ({
    buyersGuide: state.buyersGuide
});

export default connect(
    mapStateToProps,
    {}
)(BuyersGuideHeader);
